const initialCountersList = [0, 0, 0];

export { initialCountersList };
